/* BACKSTOCK — theme JS. No dependencies. */
(function () {
  'use strict';

  var RECENT_KEY = 'wh_recent';
  var recent = [];

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function on(sel, evt, fn, root) { $$(sel, root).forEach(function (el) { el.addEventListener(evt, fn); }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  }); }

  /* ---------- Search drawer ---------- */

  var drawer, overlay, input, resultsEl, emptyEl, viewAll, recentWrap, recentEl;
  var lastQuery = '', timer = null, controller = null;

  function openSearch() {
    if (!drawer) return;
    drawer.dataset.open = 'true';
    overlay.dataset.open = 'true';
    document.body.style.overflow = 'hidden';
    renderRecent();
    setTimeout(function () { input && input.focus(); }, 60);
  }

  function closeSearch() {
    if (!drawer) return;
    drawer.dataset.open = 'false';
    overlay.dataset.open = 'false';
    document.body.style.overflow = '';
  }

  function saveRecent(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    recent = recent.filter(function (r) { return r !== q; });
    recent.unshift(q);
    recent = recent.slice(0, 6);
    renderRecent();
  }

  function renderRecent() {
    if (!recentWrap) return;
    if (!recent.length) { recentWrap.hidden = true; return; }
    recentWrap.hidden = false;
    recentEl.innerHTML = recent.map(function (q) {
      return '<a class="qtag" style="margin:0 6px 6px 0;display:inline-block" href="/search?q=' +
        encodeURIComponent(q) + '&type=product">' + esc(q) + '</a>';
    }).join('');
  }

  function renderResults(data, q) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
    var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];

    if (!products.length && !collections.length && !queries.length) {
      resultsEl.innerHTML = '<div class="sr-empty">No warehouse stock matches &ldquo;' + esc(q) + '&rdquo;</div>';
      return;
    }

    var html = '';

    if (queries.length) {
      html += '<div class="sr-group"><h4>Suggestions</h4><div>' +
        queries.slice(0, 5).map(function (s) {
          return '<a class="qtag" style="margin:0 6px 6px 0;display:inline-block" href="' +
            esc(s.url) + '">' + esc(s.text) + '</a>';
        }).join('') + '</div></div>';
    }

    if (products.length) {
      html += '<div class="sr-group"><h4>Titles</h4>' + products.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + esc(p.featured_image.url) + '" alt="" loading="lazy">'
          : '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="">';
        return '<a class="sr-item" href="' + esc(p.url) + '">' + img +
          '<span><span class="sr-item__v">' + esc(p.vendor || '') + '</span>' +
          '<span class="sr-item__t">' + esc(p.title) + '</span></span>' +
          '<span class="sr-item__p">' + esc(p.price ? formatMoney(p.price) : '') + '</span></a>';
      }).join('') + '</div>';
    }

    if (collections.length) {
      html += '<div class="sr-group"><h4>Aisles</h4>' + collections.slice(0, 5).map(function (c) {
        return '<a class="sr-item" href="' + esc(c.url) + '"><span class="sr-item__t">' + esc(c.title) + '</span></a>';
      }).join('') + '</div>';
    }

    resultsEl.innerHTML = html;
  }

  function formatMoney(v) {
    // suggest.json returns a formatted string on most shops; fall back to raw
    if (typeof v === 'string' && /[^0-9.]/.test(v)) return v;
    var n = parseFloat(v);
    return isNaN(n) ? '' : '$' + (n / (n > 1000 ? 100 : 1)).toFixed(2);
  }

  function runSearch(q) {
    if (q.length < 2) {
      resultsEl.innerHTML = '';
      emptyEl.hidden = false;
      return;
    }
    emptyEl.hidden = true;

    if (controller) controller.abort();
    controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';

    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (d) { renderResults(d, q); })
      .catch(function (e) { if (e && e.name !== 'AbortError') resultsEl.innerHTML = ''; });

    if (viewAll) viewAll.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
  }

  /* ---------- Mega menu ---------- */

  function closeMegas(except) {
    $$('.mega-panel').forEach(function (p) {
      if (p !== except) p.dataset.open = 'false';
    });
    $$('[data-mega-trigger]').forEach(function (t) {
      if (t.dataset.megaTrigger !== (except && except.dataset.mega)) {
        t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- Boot ---------- */

  document.addEventListener('DOMContentLoaded', function () {
    drawer = $('#search-drawer');
    overlay = $('#search-overlay');
    input = $('#wh-search');
    resultsEl = $('#sr-results');
    emptyEl = $('#sr-empty');
    viewAll = $('#sr-viewall');
    recentWrap = $('#sr-recent-wrap');
    recentEl = $('#sr-recent');

    on('[data-search-open]', 'click', function (e) { e.preventDefault(); openSearch(); });
    on('[data-search-close]', 'click', closeSearch);

    if (input) {
      input.addEventListener('input', function () {
        var q = this.value.trim();
        if (q === lastQuery) return;
        lastQuery = q;
        clearTimeout(timer);
        timer = setTimeout(function () { runSearch(q); }, 180);
      });
      var frm = input.closest('form');
      if (frm) frm.addEventListener('submit', function () { saveRecent(input.value); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeSearch(); closeMegas(null); }
      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); openSearch(); }
      if (e.key === '/' && !/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) {
        e.preventDefault(); openSearch();
      }
    });

    /* Mega menu triggers */
    on('[data-mega-trigger]', 'click', function (e) {
      e.preventDefault();
      var panel = document.getElementById('mega-' + this.dataset.megaTrigger);
      if (!panel) return;
      var willOpen = panel.dataset.open !== 'true';
      closeMegas(willOpen ? panel : null);
      panel.dataset.open = willOpen ? 'true' : 'false';
      this.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.mega-wrap') && !e.target.closest('[data-mega-trigger]')) closeMegas(null);
    });

    /* Mobile nav */
    on('[data-nav-toggle]', 'click', function () {
      var nav = $('#site-nav');
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      this.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    /* Mobile facet drawer */
    on('[data-facets-toggle]', 'click', function () {
      var f = $('#facets');
      if (!f) return;
      var open = f.classList.toggle('is-open');
      this.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.textContent = open ? 'Hide filters' : 'Filters';
    });

    /* Auto-submit filter and sort controls */
    on('[data-auto-submit]', 'change', function () {
      var form = this.closest('form');
      if (form) form.submit();
    });

    /* Tabs */
    on('[role="tab"]', 'click', function () {
      var group = this.closest('[data-tabs]');
      if (!group) return;
      $$('[role="tab"]', group).forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
      $$('[role="tabpanel"]', group).forEach(function (p) { p.hidden = true; });
      this.setAttribute('aria-selected', 'true');
      var panel = document.getElementById(this.getAttribute('aria-controls'));
      if (panel) panel.hidden = false;
    });
  });
})();
